import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { API_BASE_URL } from '../App';

async function persistShareNudgeOptOut(setUser) {
  const session = Cookies.get('session');
  if (!session) return;
  try {
    const res = await fetch(`${API_BASE_URL}/user/settings`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: session,
      },
      body: JSON.stringify({ shareEngagementNudgeEnabled: false }),
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.user && setUser) {
      setUser(data.user);
    }
  } catch {
    /* best-effort */
  }
}

function ShareEngagementNudgeModal({ isOpen, milestone, onClose, onYes, setUser }) {
  const [optOut, setOptOut] = useState(false);

  if (!isOpen) return null;

  const finish = async (openInvite) => {
    if (optOut) {
      await persistShareNudgeOptOut(setUser);
    }
    setOptOut(false);
    if (openInvite) {
      onYes();
    } else {
      onClose();
    }
  };

  return (
    <div className="share-nudge-overlay" onClick={() => finish(false)}>
      <div
        className="share-nudge-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="share-nudge-title"
      >
        <div className="share-nudge-modal__accent" aria-hidden="true" />
        <p className="share-nudge-modal__eyebrow">Milestone reached{milestone ? ` · ${milestone} plates` : ''}</p>
        <h2 id="share-nudge-title" className="share-nudge-modal__title">
          Thanks for being a dedicated PlateChase player!
        </h2>
        <p className="share-nudge-modal__text">
          You&apos;re on a roll. Know someone who&apos;d love spotting plates on the road? Share PlateChase with
          your friends.
        </p>

        <label className="share-nudge-modal__opt-out">
          <input
            type="checkbox"
            checked={optOut}
            onChange={(e) => setOptOut(e.target.checked)}
          />
          <span>Don&apos;t show these invite prompts again</span>
        </label>

        <div className="share-nudge-modal__actions">
          <button type="button" className="share-nudge-modal__btn share-nudge-modal__btn--primary" onClick={() => finish(true)}>
            Yes, invite friends
          </button>
          <button type="button" className="share-nudge-modal__btn share-nudge-modal__btn--secondary" onClick={() => finish(false)}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShareEngagementNudgeModal;
